import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Sales from "@/pages/Sales";
import Expenses from "@/pages/Expenses";
import Pricesheet from "@/pages/Pricesheet";
import CalculatorPage from "@/pages/CalculatorPage";
import MyPrices from "@/pages/MyPrices";
import ImeiCheck from "@/pages/ImeiCheck";
import Shipments from "@/pages/Shipments";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
      <Route path="/inventory" element={<ProtectedRoute><AppLayout><Inventory /></AppLayout></ProtectedRoute>} />
      <Route path="/sales" element={<ProtectedRoute><AppLayout><Sales /></AppLayout></ProtectedRoute>} />
      <Route path="/expenses" element={<ProtectedRoute><AppLayout><Expenses /></AppLayout></ProtectedRoute>} />
      <Route path="/pricesheet" element={<ProtectedRoute><AppLayout><Pricesheet /></AppLayout></ProtectedRoute>} />
      <Route path="/my-prices" element={<ProtectedRoute><AppLayout><MyPrices /></AppLayout></ProtectedRoute>} />
      <Route path="/calculator" element={<ProtectedRoute><AppLayout><CalculatorPage /></AppLayout></ProtectedRoute>} />
      <Route path="/imei" element={<ProtectedRoute><AppLayout><ImeiCheck /></AppLayout></ProtectedRoute>} />
      <Route path="/shipments" element={<ProtectedRoute><AppLayout><Shipments /></AppLayout></ProtectedRoute>} />
    </Routes>
  );
}

function AppContent() {
  const { theme } = useTheme();
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme={theme} position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
